// src/components/ContactPage/ContactPage.js
import React, { useState } from "react";
import { Phone, Mail } from 'lucide-react';
import { Link } from "react-router-dom";
import styles from "./ContactPage.module.css";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_key: "bdd90f5b-e30e-4ab1-8bc2-d1129c5ab12a",
          ...formData,
        }),
      });
      if (response.ok) {
        setFormData({ name: "", email: "", phone: "", message: "" });
        alert("Message sent successfully!");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className={styles.container} id="contact">
      <div className={styles.content}>
        <div className={styles.zy}>
          <h1 className={styles.title}>
            Get in <span className={styles.highlight}>Touch</span>
          </h1>

          <form onSubmit={handleSubmit} className={styles.form}>
            <input
              type="text"
              name="name"
              placeholder="Name *"
              required
              value={formData.name}
              onChange={handleChange}
              className={styles.input}
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className={styles.input}
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone number *"
              required
              value={formData.phone}
              onChange={handleChange}
              className={styles.input}
            />
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              className={styles.input}
              rows={4}
            />
            <button type="submit" className={styles.button}>
              SEND
            </button>
          </form>

          <div className={styles.contactInfo}>
            <div className={styles.contactItem}>
              <Phone className={styles.icon} />
              <a href="tel:09337813196" className={styles.link}>
                09337 813196
              </a>
            </div>
            <div className={styles.contactItem}>
              <Mail className={styles.icon} />
              <a href="mailto:contact@teezash.com" className={styles.link}>
                contact@teezash.com
              </a>
            </div>
          </div>
        </div>

        <div className={styles.map}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2209.2742279502327!2d84.88753252105401!3d22.26067551842568!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a201d0045005199%3A0x17e4b5b4090159d0!2sTeezash%20Technologies%20Pvt.%20Ltd.!5e1!3m2!1sen!2sin!4v1738908299309!5m2!1sen!2sin"
            width="400"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Teezash Technologies Location"
          />
        </div>
      </div>

      <footer className={styles.footer}>
        <nav className={styles.quickLinks}>
          <span className={styles.quickLinksTitle}>Quick Links</span>
          <div className={styles.links}>
            <a href="#vision" onClick={() => scrollToSection('vision')}>Vision</a>
            <a href="#work" onClick={() => scrollToSection('work')}>Work</a>
            <a href="#why" onClick={() => scrollToSection('why')}>Why</a>
            <a href="#team" onClick={() => scrollToSection('team')}>Team</a>
            <a href="#journey" onClick={() => scrollToSection('journey')}>Journey</a>
            <a href="#contact" onClick={() => scrollToSection('contact')}>Contact</a>
          </div>
        </nav>

        <div className={styles.footerContent}>
          <div className={styles.logo}>
            <svg
              width="38"
              height="31"
              viewBox="0 0 38 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_82_418)">
                <path
                  d="M19.3742 0H0.000244141L5.11859 6.13102H17.9714L19.3742 8.00863L19.45 31L24.7579 25.4438V6.13102L19.3742 0Z"
                  fill="white"
                />
                <path
                  d="M37.9895 0H20.7009L25.933 6.13102H32.947L37.9895 0Z"
                  fill="white"
                />
                <path
                  d="M17.5161 7.08899H13.2698L13.2319 25.597L18.5398 31V8.27688L17.5161 7.08899Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_82_418">
                  <rect width="38" height="31" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <p className={styles.mission}>
            Our mission at Teezash is to harness the potential of IoT to build safer, smarter, and more connected environments.{" "}
            <a href="mailto:contact@teezash.com" className={styles.joinUs}>
              Join Us
            </a>
          </p>
        </div>

        <div className={styles.footerBottom}>
          <div className={styles.legal}>
            <Link to="/terms" className={styles.legalLink}>Terms</Link>
            <Link to="/privacy" className={styles.legalLink}>Privacy</Link>
          </div>
          <div className={styles.socials}>
            <a
              href="https://www.youtube.com/@TeezashTechnologies"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <div className={styles.socialIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
                </svg>
              </div>
            </a>
            <a
              href="https://x.com/Teezash_tech"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <div className={styles.socialIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                </svg>
              </div>
            </a>
            <a
              href="https://www.linkedin.com/company/teezash-technologies"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <div className={styles.socialIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
                </svg>
              </div>
            </a>
            <a
              href="https://github.com/teezash"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <div className={styles.socialIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8" />
                </svg>
              </div>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;